import React, { useEffect } from 'react';
import { Loader } from 'pixi.js'
import {  Sprite, Container} from '@inlet/react-pixi'
import { ease } from 'pixi-ease'

const Cloud = ({ _xPos, _yPos, speed, max, min, _xSize, _ySize, _time }) => {
    const loader = Loader.shared;
    const cloudSprite = React.useRef();
    let cloudTexture = loader.resources["./assets/images/components/island/spritesheets/skyAssets/cloud.json"].textures[`cloud-night-v020.png`];
    if (_time === "day")
        cloudTexture = loader.resources["./assets/images/components/island/spritesheets/skyAssets/cloud.json"].textures[`cloud-afternoon-v01.png`];

    useEffect(() => {
        if (cloudSprite.current !== null && cloudSprite.current !== undefined) {
            ease.target(cloudSprite.current, { x: max, y: _yPos }, speed, { reverse: true, repeat: true })
        }
    }, []);

    return (
        <Container x={_xPos} y={_yPos} ref={cloudSprite}>
            <Sprite
                scale={{ x: _xSize, y: _ySize }}
                texture={cloudTexture}
            />
        </Container>
    );
};

export { Cloud as default }